$(function () {
    $(".tab_nav li:first-child").addClass("active"), $(".tabcontent").hide(), $(".tabcontent:first").show(), $(".tab_nav li").click(function () {
        $(".tab_nav li").removeClass("active"), $(this).addClass("active"), $(".tabcontent").hide();
        var e = $(this).find("a").attr("href");
        return $(e).fadeIn(), !1
    });
    $(".ques-heading").click(function (e) {
        var t = $(this).closest(".questions__item_row").find(".ques-desc");
        $(this).closest(".question-body").find(".ques-desc").not(t).slideUp(), 
        $(this).hasClass("active") ? $(this).removeClass("active") : ($(".ques-heading.active").removeClass("active"), 
        $(this).addClass("active")), 
        t.stop(!1, !0).slideToggle(), e.preventDefault()
    })
    $('.tab-header-item').click(function(){
        $('.tab-header-item').each(function(){
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        $('.tab-content-item').hide();
        var to_open = $(this).attr('tab_content');
        $(`[content="${to_open}"]`).show()
    });
    $('.tab-header-item-mob').click(function(){
        $(this).toggleClass('active');
        var to_open = $(this).attr('tab_content');
        $(`[content="${to_open}"]`).slideToggle();
    });
    $(".review_main_slider").slick({
        infinite: !0,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: !0,
        autoplay: !0,
        autoplaySpeed: 2e3,
        dots: !1,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    })
})